import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Flex, Heading, Box, Text, List, ListItem, UnorderedList } from "@chakra-ui/react";

import { Waypoint } from "react-waypoint";
import { useLocation } from "react-router-dom";
//images
import bg from "../../assets/images/Logobg.jpeg";
import Who1 from "../../assets/images/who1.jpg";
import Team from "../../assets/images/team.jpg";

const ServiceSection = ({ title, items }) => (
  <Box
    borderWidth="0px"


    color={"whiteAlpha.900"}

    shadow="sm"
    _hover={{ shadow: "md" }}
    transition="0.3s"
  >
    <Heading fontSize={["18px", "20px", "22px"]} mb={4}>
      {title}
    </Heading>

    <List
      spacing={2}
      styleType="disc"
      stylePosition="outside"
      pl={6}
    >
      {items.map((item, index) => (
        <ListItem
          key={index}
          color="whiteAlpha.900"
          fontSize={{ base: "1.8rem", md: "2rem" }}
        >
          {item}
        </ListItem>
      ))}
    </List>
  </Box>
);


const About = () => {

  let params = useLocation();
  useEffect(() => {
    if (params?.state?.id)
      document.querySelector(`${params.state.id}`).scrollIntoView(true);
    else window.scrollTo(0, 0);
  }, [params.state, useLocation().state]);







  return (
    <Flex flexDirection={"column"} alignItems={"center"}>
      <Helmet>
        <html lang="en" />

        <title>
          About AKIA Flow Assurance | Flow Assurance & Process Engineering Experts
        </title>

        <meta
          name="description"
          content="Learn about AKIA Flow Assurance, a consultancy specializing in flow assurance and process engineering services for oil & gas, pipeline, and industrial systems worldwide."
        />

        <meta
          name="keywords"
          content="About AKIA Flow Assurance, Flow Assurance Consultant, Process Engineering Consultancy, Oil and Gas Engineering, Pipeline Engineering, Engineering Experts"
        />

        <meta name="author" content="AKIA Flow Assurance" />
        <meta name="robots" content="index, follow" />

        <meta
          property="og:title"
          content="About AKIA Flow Assurance"
        />

        <meta
          property="og:description"
          content="Experienced consultancy specializing in flow assurance, pipeline hydraulics, and process engineering studies."
        />

        <link
          rel="canonical" href="https://akiaflowassurance.com/about" />
        
      </Helmet>

      <Flex
        bg={`linear-gradient(rgba(0, 0, 0, 0.85), rgba(0, 0, 0, 0.85)), url(${bg})`}
        backgroundSize={"cover"}
        backgroundPosition={"bottom"}
        h={"100vh"}
        w="100vw"

        minH="100vh"
        color={"whiteAlpha.900"}
        flexDirection={"column"}

        alignItems="center"
        justifyContent="center"


        pl={{ base: "0rem", md: "10rem", lg: "35rem" }}
      >


        <Box
          width={"fit-content"}
          transform={{
            base: "",
            md: "translateX(-10vw)",
            lg: "translateX(-15vw)",
          }}
          px={"3rem"}
        >
          <Flex
            overflow={"hidden"}
            maxW={"100rem"}
            pos={"relative"}
            overflowX={"hidden"}
            w={"fit-content"}
          >
            <Waypoint
              onEnter={() =>
              (document.querySelector("#animateMain5").style.animation =
                "heading 1.5s ease")
              }
            >
              <Flex id="animateMain5">
             <Heading
                               flexShrink={"0"}
                               textTransform={"uppercase"}
                               fontSize={{ base: "3.0rem", "3sm": "4.5rem", lg: "5.0rem" }}
                               maxW={"100rem"}
                               color={"whiteAlpha.900"}
                               fontFamily={"Roboto Condensed, Lato, sans-serif"}
                               textAlign="center"
             mt={"8rem"}
                               w={"100%"}
                             >
                
                  About AKIA
                </Heading>
                <Box
                  w={"100%"}
                  h={"100%"}
                  bg={"whiteAlpha.900"}
                  flexShrink={"0"}
                />
              </Flex>
            </Waypoint>
          </Flex>
          <Flex
            overflow={"hidden"}
            maxW={"100rem"}
            pos={"relative"}
            overflowX={"hidden"}
            w={"fit-content"}
            mt={"1rem"}
          >
            <Waypoint
              onEnter={() =>
              (document.querySelector("#animateMain4").style.animation =
                "heading 1.5s ease")
              }
            >
              <Flex id="animateMain4">
                <Text
                  textAlign={{ base: "justify", md: "justify" }}
                  fontSize={{ base: "1.8rem", md: "2rem" }}
                  maxW={"100rem"}
                  flexShrink={"0"}
                  w={"100%"}
                >
                  AKIA Flow Assurance is a UAE-based engineering consultancy specializing in Flow Assurance studies and Process Engineering Support for oil & gas production facilities, pipelines, and utility systems.<br/><br/>

We support operators, EPCs, and engineering contractors through simulation-driven studies, hydraulic analysis, and practical engineering solutions for offshore and onshore developments worldwide.<br/><br/>

Our focus is on delivering technically sound, cost-effective, and fit-for-purpose engineering studies, particularly for small to medium-sized projects requiring specialist expertise and responsive support.

                  

                


                </Text>
                <Box
                  bg={"whiteAlpha.900"}
                  h={"100%"}
                  w={"100%"}
                  flexShrink={"0"}
                ></Box>
              </Flex>
            </Waypoint>
          </Flex>
        </Box>
      </Flex>

      {/* Next Section */}

      {/* Next Section */}
      <Flex
        py={"4rem"}
        px={{ base: "1rem", "3sm": "8rem" }}
        flexDirection={"column"}
        alignItems={"center"}>




        <Waypoint
          onEnter={() =>
            (document.querySelector("#animate12").style.animation = "fadeUp 1.5s")
          }>
          <Flex
            id="animate12"
            justifyContent={"center"}
            maxW={"1440px"}
            py={"4rem"}
            px={{ base: "1rem", "3sm": "8rem" }}
            w={"100%"}
            gap={{ base: "8rem", lg: "8rem" }}
            flexDir={{ base: "column", lg: "row" }}>
            <Flex
              border={"2px solid rgb(236, 24, 24)"}
              borderRadius="2xl"
              bg={"#17262E"}
              px={{ base: "2rem", "3sm": "4rem" }}
              py={{ base: "3rem", "3sm": "4rem" }}
              flex={"0 0 50%"}
              flexDirection={"column"}
              color={"whiteAlpha.900"}
              textAlign={"justify"}
              boxShadow={"0 0 10px 0 rgba(0, 0, 0, 0.5)"}
              id="strength">
              <Heading
                mb={"1.5rem"}
                fontSize={{base: "2.5rem", md: "3rem"}}
                textTransform={"uppercase"}>
                Our Strength
              </Heading>
              <Box bg={"#EA0F0F"} h="5px" w={"6rem"} mb={"3.0rem"}></Box>

              <ServiceSection

                items={[
                  "Over 15 years of combined experience in Flow Assurance and Process Engineering",
                  "Proficient in industry-standard tools: OLGA, PIPESIM, HYSYS, and PVTSim",
                  "Deep expertise in multiphase flow, steady-state and transient analysis",
                  "Quick turnaround engineering studies to support urgent project needs",
                  "Specialized consultancy focused on Flow Assurance and production system analysis",
                  "Flexible engagement with cost-effective solutions to suit small and medium project scopes",
                ]}
              />


            </Flex>




            <Flex
              bg={"#17262E"}
              border={"2px solid rgb(236, 24, 24)"}
              borderRadius="2xl"
              px={{ base: "2rem", "3sm": "4rem" }}
              py={{ base: "3rem", "3sm": "4rem" }}
              flex={"0 0 50%"}
              color={"whiteAlpha.900"}
              flexDirection={"column"}
              textAlign={"justify"}
              boxShadow={"0 0 10px 0 rgba(0, 0, 0, 0.5)"}
              id="team"
            >
              <Heading
                mb={"1.5rem"}
                fontSize={{base: "2.5rem", md: "3rem"}}
                textTransform={"uppercase"}
              >
                Our Team
              </Heading>
              <Box bg={"#EA0F0F"} h="5px" w={"6rem"} mb={"3.0rem"}></Box>
              <Text fontSize={{ base: "1.8rem", md: "2rem" }}>
                Our team consists of experienced engineers specialized in:

                <ServiceSection

                  items={[
                    "Flow Assurance",
                    "Process Engineering",
                    "Pipeline Hydraulics",
                    "Simulation & Modeling"
                  ]}
                />




                We are committed to delivering accurate, practical, and timely engineering studies, helping clients address complex flow assurance, hydraulic, and process system challenges with confidence.
              </Text>
            </Flex>
          </Flex>
        </Waypoint>

        {/* Next Section */}
        <Waypoint
          onEnter={() =>
            (document.querySelector("#animate14").style.animation = "fadeUp 1.5s")
          }
        >
          <Flex
            id="animate14"
            justifyContent={"center"}
            maxW={"1440px"}
            py={"4rem"}
            px={{ base: "1.5rem", "3sm": "8rem" }}
            w={"100%"}
            gap={{ base: "8rem", lg: "8rem" }}
            flexDir={{ base: "column", lg: "row" }}
          >
            <Flex
              border={"2px solid rgb(236, 24, 24)"}
              borderRadius="2xl"
              bg={"#17262E"}
              px={{ base: "2rem", "3sm": "4rem" }}
              py={{ base: "3rem", "3sm": "4rem" }}
              flex={"0 0 50%"}
              flexDirection={"column"}
              color={"whiteAlpha.900"}
              textAlign={"justify"}
              boxShadow={"0 0 10px 0 rgba(0, 0, 0, 0.5)"}
              id="mission"
            >
              <Heading
                mb={"1.5rem"}
                fontSize={{base: "2.5rem", md: "3rem"}}
                textTransform={"uppercase"}
              >
                Our Mission
              </Heading>
              <Box bg={"#EA0F0F"} h="5px" w={"6rem"} mb={"3.0rem"}></Box>



              <ServiceSection

                items={[
                  "Deliver accurate, reliable, and simulation-driven engineering studies",
                  "Provide responsive and cost-effective technical support",
                  "Help clients optimize production systems, pipelines, and utility systems",
                  "Build long-term partnerships through practical engineering solutions"
                ]}
              />


            </Flex>



            <Flex
              border={"2px solid rgb(236, 24, 24)"}
              borderRadius="2xl"
              bg={"#17262E"}
              border={"2px solid rgb(236, 24, 24)"}
              px={{ base: "2rem", "3sm": "4rem" }}
              py={{ base: "3rem", "3sm": "4rem" }}
              flex={"0 0 50%"}
              flexDirection={"column"}
              color={"whiteAlpha.900"}
              textAlign={"justify"}
              boxShadow={"0 0 10px 0 rgba(0, 0, 0, 0.5)"}
              id="vision"
            >
              <Heading
                mb={"1.5rem"}
                fontSize={{base: "2.5rem", md: "3rem"}}
                textTransform={"uppercase"}
              >
                Our Vision
              </Heading>
              <Box bg={"#EA0F0F"} h="5px" w={"6rem"} mb={"3.0rem"}></Box>
              <Text fontSize={{ base: "1.8rem", md: "2rem" }}>
                To be a trusted specialist in Flow Assurance and Process Engineering Support for oil & gas production facilities, pipelines, and utility systems.
              </Text>
            </Flex>
          </Flex>
        </Waypoint>
      </Flex>
      {/* Next Section */}

      <Flex
        width={"100vw"}
        alignItems={"center"}
        justifyContent={"space-evenly"}
        flexDirection={{ base: "column", md: "row" }}
        py={"6rem"}
      >
        <Heading
          textTransform={"uppercase"}
          fontWeight={"700"}
          fontSize={{ base: "2.2rem", md: "2.5rem" }}
        >
          Connect with us
        </Heading>
        <Flex alignItems={"center"} mt={{ base: "2rem", md: "0" }}>
          <a
            id="phone"
            style={{ flex: "0 0 22%" }}
            href="https://wa.me/+971501232838"
          >

            <Heading fontSize={"4rem"}>
              <i
                className="fa-brands fa-square-whatsapp"
                style={{ color: "green" }}
              />
            </Heading>



          </a>
              <a href="https://www.linkedin.com/company/akia-flow-assurance/" target="_blank">
            <i
              style={{
                fontSize: "4rem",
                margin: "0 1rem",
                color: "#EA0F0F",
                cursor: "pointer",
              }}
              className="fa-brands fa-linkedin"
            ></i>
          </a>

          <a href="https://www.youtube.com/@AKIAFlowAssurance" target="_blank">
            <i
              style={{
                fontSize: "4rem",
                margin: "0 1rem",
                color: "#EA0F0F",
                cursor: "pointer",
              }}
              className="fa-brands fa-square-youtube"
            ></i>
          </a>



          <a href="https://www.facebook.com/AKIAFlowAssurance" target="_blank">
            <i
              style={{
                fontSize: "4rem",
                margin: "0 1rem",
                color: "#EA0F0F",
                cursor: "pointer",
              }}
              className="fa-brands fa-square-facebook"
            ></i>
          </a>
          <a href="https://www.instagram.com/akiaflowassurance/" target="_blank">
            <i
              style={{
                fontSize: "4rem",
                margin: "0 1rem",
                color: "#EA0F0F",
                cursor: "pointer",
              }}
              className="fa-brands fa-square-instagram"
            ></i>
          </a>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default About;
